import { useTheme } from 'styled-components';

import CustomIcon from '@components/utils/CustomIcon';
import { InfoIcon } from '@assets/icons';

import Tooltip from '../Tooltip/next';
import {
  WrapperInfo,
  TextWrapper,
  ColCustomIcon,
  ContainerInfo,
  Text,
  InfoBadge,
} from './styled';

const GuestSupportBanner = ({ type }: { type?: string }) => {
  const { palette } = useTheme();
  return (
    <Tooltip
      overlayInnerStyle={{
        backgroundColor: palette.white,
        color: palette.darkGray,
        lineHeight: 1.43,
        width: '200px',
        borderRadius: '8px',
        boxShadow:
          '0 3px 6px -4px rgba(0,0,0,.12), 0 6px 16px 0 rgba(0,0,0,.08), 0 9px 28px 8px rgba(0,0,0,.05)',
      }}
      placement='topLeft'
      showArrow={false}
      title={
        <TextWrapper>
          <Text>
            Setur misafir memnuniyeti anketleri baz alınmıştır. Anketlere
            katılan misafirlerin çoğunluğunun memnun olduğu oteller seçilmiştir.
          </Text>
        </TextWrapper>
      }
    >
      <ContainerInfo hotelType={type === 'hotel' ? true : false}>
        <WrapperInfo>
          <ColCustomIcon>
            <CustomIcon
              icon={InfoIcon}
              fontSize={16}
              fill={type === 'hotel' ? palette.NL800 : palette.darkSuccess}
            />
          </ColCustomIcon>

          <InfoBadge hotelType={type === 'hotel' ? true : false}>
            Misafirler Öneriyor
          </InfoBadge>
        </WrapperInfo>
      </ContainerInfo>
    </Tooltip>
  );
};

export default GuestSupportBanner;
